import { checkDefined } from 'faro-common-model';
import { z } from 'zod';
import { nullishToUndefined } from '../utils/nullishToUndefined.js';
export const namedObjectSchema = z.object({
    id: z.string().nullish().transform(nullishToUndefined).optional(),
    name: z.string().describe('name is required'),
});
export const requiredNamedObjectSchema = z.object({
    ...namedObjectSchema.shape,
    id: z.string().describe('id is required'),
});
export function toNamedObject(namedObject) {
    if (namedObject == null)
        return;
    return namedObjectSchema.parse(namedObject);
}
export function toRequiredNamedObject(namedObject) {
    if (namedObject == null)
        return;
    return requiredNamedObjectSchema.parse(namedObject);
}
/**
 * Checks that the object values is not null/undefined and has a valid id
 *
 * @param value            the value to check
 * @param objectName       the object name the value belongs to
 * @param propertyName     the property name this value represents
 * @throws IllegalArgumentError if the given value is null or undefined
 * @return the validated value
 *
 * @deprecated this shouldn't be required
 */
export function checkValidNamedObject(value, objectName, propertyName) {
    checkDefined(value === null || value === void 0 ? void 0 : value.id, objectName, propertyName);
    return value;
}
//# sourceMappingURL=named-object.js.map